import { styled } from 'styled-components'

export const CustomerWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${props => `${props.theme.marginSM}px`};
`
